<template>
  <footer class="footer">
    <div class="footer__inner">

      <template v-if="type === 'signin'">
        <h3 class="footer__heading">Already have a <span>Hull City Hub</span>?</h3>
        <router-link class="buffer-bottom" to="/">Sign in here</router-link>
        <p>Having problems or want help with your <strong>Hull City Hub</strong>?</p>
        <a :href="configStrings.clubSSOHelpLink" >Account help</a>
      </template>

      <template v-else-if="type === 'help'">

      </template>
      <div class="footer-sponsors">


      </div>
      <div class="legalLinks">
        <a :href="configStrings.clubPrivacyPolicyLink">Privacy Policy</a>
      </div>
      <div class="legalLinks">
      This website is © {{configStrings.clubName}} {{year}}. All rights reserved
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'FooterShout',
  data () {
    var d = new Date();
    return {
      year: d.getFullYear()
    }
  },
  props: {
    type: {
      type: String, // register | signin | help
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
  // @import '@/css/global.scss';

  .footer {
    position: relative;
    margin: 50px 0 0;
    padding: 60px 20px 80px;
    color: #fff;
    font-size: 18px;
    text-align: center;
    background-color: #151515;

    &:before {
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      // background: transparent url('../assets/stadium-white-out@2x.png') center right no-repeat;
      background-size: cover;
      opacity: 0.4;
      z-index: 1;
    }

    &__inner {
      position: relative;
      z-index: 3;
    }

    &__heading {
      margin: 0 0 24px;
      font-size: 32px;
      font-weight: 300;

      > span {
        font-weight: 500;
      }
    }

    a {
      color: #fff;

      // &:hover {
        // text-decoration: none;
        // color: $primary-club-light;
      // }
    }

    &__telephone {
      margin: 10px 0 0;
      font-size: 34px;
      font-weight: 300;
    }
  }

  .buffer-bottom {
    display: inline-block;
    margin-bottom: 30px;
  }

  .features {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-evenly;
    align-items: flex-start;
    margin: 40px auto 0;
    padding: 0;
    max-width: 1200px;
    list-style: none;

    &__item {
      flex-grow: 1;
      flex-basis: 0;
      margin: 0 20px 30px;
      font-size: 15px;
      font-style: normal;
      font-weight: normal;
      line-height: 1.47;
      text-align: center;

      span {
        display: block;
      }

      &:before {
        content: '';
        display: block;
        margin: 0 auto 10px;
        height: 97px;
        width: 97px;
        background-color: rgba(255, 255, 255, 0.75);
        background-position: 50%;
        background-repeat: no-repeat;
        border: 2px solid #fff;
        border-radius: 50%;
      }

      &--store:before {
        background-image: url('../assets/features/retail.svg');
        background-size: 62px;
        background-position: 50% 45%;
      }

      &--plus:before {
        background-image: url('../assets/features/club-plus.svg');
        background-size: 62px;
        background-position: 50% 45%;
      }

      &--live:before {
        background-image: url('../assets/features/club-live.svg');
        background-size: 62px;
        background-position: 50% 45%;
      }

      &--app:before {
        background-image: url('../assets/features/app.svg');
        background-size: 62px;
      }

      &--ticketing {
        opacity: 0.5;

        &:before {
          background-image: url('../assets/features/tickets.svg');
          background-size: 62px;
        }
      }
    }
  }
  .legalLinks{
    margin-top: 20px;
    font-size: 1.0rem;
  }

  .footer-sponsors {
    // background-color: footerSetting(footer_sponsors-background_color);

    &__inner {
      max-width: 1440px;
      margin: 0 auto;
      padding-top: 26px;
      text-align: center;
      display: flex;
      flex-direction: column;
      align-items: center;

      @media screen and (min-width: 760px) {
        padding-bottom: 8px;
      }
    }

    &__row {
      width: 100%;
    }

    &__row-title {
      // color: footerSetting(footer_sponsors-text_color);
      text-align: center;
    }

    &__sponsor-wrapper {
      margin: 0 auto;
      list-style-type: none;
      display: flex;
      flex-direction: row;
      align-items: center;
      flex-wrap: wrap;
      padding-left: 0;

      &--small {
        justify-content: center;

        @media screen and (min-width: 760px) {
          max-width: 720px;
        }

        @media screen and (min-width: 1024px) {
          max-width: 1032px;
        }
      }

      &--large {
        padding-bottom: 16px;
        justify-content: center;

        @media screen and (min-width: 760px) {
          padding-bottom: 12px;
        }

        @media screen and (min-width: 1024px) {
          max-width: 1032px;
          padding-bottom: 0;
        }
      }
    }

    &__sponsor {
      display: flex;
      align-items: center;

      &--small {
        width: 80px;
        height: 80px;
        margin: 0 12px 24px;

        @media screen and (min-width: 760px) {
          width: 96px;
          height: 96px;
        }

        @media screen and (min-width: 1024px) {
          margin: 0 26px 24px;
        }
      }

      &--large {
        width: 132px;
        height: 132px;
        margin: 0 12px 24px;

        @media screen and (min-width: 375px) {
          width: 160px;
          height: 160px;
        }

        @media screen and (min-width: 760px) {
          margin: 0 20px 32px;
        }

        @media screen and (min-width: 1024px) {
          margin: 0 22px 28px;
        }
      }
    }

    &__logo {
      display: block;
      height: 100%;
      width: 100%;
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;
    }
  }

</style>